import "@node/emoji-picker-element";
import {QbElement} from "./qb-element.js"

class QbEmojiPicker extends customElements.get("emoji-picker") {
    #onemojiclick

    connectedCallback() {
        super.connectedCallback();
        const sheet = this.shadowRoot.firstElementChild.sheet;
        sheet.insertRule(`.emoji-menu {
                grid-template-columns: repeat(auto-fill, minmax(calc(var(--emoji-size) * 1.2), 1fr))!important;
                column-gap: var(--raster_1_2);
        }`);
        sheet.insertRule(`.tabpanel { padding-right: var(--raster_1_2) }`);

        this.shadowRoot.lastElementChild.setAttribute("part", "picker");
    }


    static get observedAttributes() {
        return super.observedAttributes.concat("onemojiclick");
    }

    set onemojiclick(value) {
        if(typeof value === "string") {
            value = new Function("event", value).bind(this);
        }
        this.#onemojiclick = value;
        this.removeEventListener("emoji-click", this);
        if(value) this.addEventListener("emoji-click", this);
    }

    _set(prop, newValue) {
        switch(prop) {
            case "onemojiclick":
                return this.onemojiclick = newValue;
        }
        super._set(prop, newValue);
    }

    handleEvent(evt) {
        switch(evt.type) {
            case "emoji-click":
                if(!this.#onemojiclick) return;
                Object.defineProperty(evt, "data", {value: evt.detail.unicode});
                return this.#onemojiclick(evt);
        }
    }


}

if(!customElements.get('qb-emoji-picker')) { // if already defined, do nothing (e.g. same script imported twice)
    customElements.define('qb-emoji-picker', QbEmojiPicker);
}

class QbProfileChooser extends QbElement {
    static observedAttributes = ["itemid"];
    static shadow = {mode: 'open', sheets: ["qb-elements"]}
    static template = `
    <header></header>
    <button type="button" class="nobutton" popovertarget="picker" name="profile[avatar]"><qb-user></qb-user></button>
<!--    <input type="text" name="profile[avatar]">-->
    <input type="text" name="profile[name]" autocomplete="off" data-_placeholder="Min 3 letters" required="required" pattern=".*[A-Za-z0-9].*[A-Za-z0-9].*[A-Za-z0-9].*" placeholder="Min 3 letters">
    <button type="button" class="nobutton" class="color"><i-colorchooser></i-colorchooser></button>
    <input type="color" name="profile[color]" value="#888888">
    <div></div>
    <qb-emoji-picker id="picker" popover="auto"></qb-emoji-picker>
`;


    #headerNode
    #nameNode
    #colorButton
    #colorNode
    #colorExplain
    #avatarNode
    #pickerNode

    constructor() {
        super();
        [this.#headerNode, this.#avatarNode, this.#nameNode, this.#colorButton, this.#colorNode, this.#colorExplain, this.#pickerNode] = this.shadowRoot.children;
        setTimeout(()=>{
            let text = _("Choose your nickname and avatar");
            this.#headerNode.textContent = text;
            text = _("and your color");
            this.#colorExplain.textContent = text;

        }, 100);
        this.#nameNode.addEventListener('change', this);
        this.#colorNode.addEventListener('input', this);
        this.#colorNode.addEventListener('input', this);
        this.#colorButton.addEventListener('click', this);
        this.#pickerNode.addEventListener("emoji-click", this)
    }

    $itemid(value) {
        if(!value) return;
        this.user.itemid = value;
        this.name = this.user.name;
        this.color = this.user.color;
        this.avatar = this.user.avatar;
    }

    get user() {
        return this.shadowRoot.querySelector("qb-user");
    }

    handleEvent(evt) {

        // if(evt.type === "emoji-click") return this.avatar = evt.detail.unicode;
        switch(evt.currentTarget) {
            case this.#colorButton:
                return this.#colorNode.click();
            case this.#colorNode:
                this.color = evt.target.value;
                break;
            case this.#pickerNode:
                this.avatar = evt.detail.unicode;
                break;
            case this.#nameNode:
                this.name = evt.target.value;
                break;
            default:
                return;
        }

        this.user.save(Object.compact({color: this.color, name: this.name, avatar: this.avatar}));
    }

    set name(value) {
        this.#nameNode.value = value;
    }

    get name() { return this.#nameNode.value }

    set avatar(value) {
        this.#avatarNode.style.setProperty("--slot-avatar", `"${value}"`);
    }

    get avatar() {

        return this.#avatarNode.style.getPropertyValue("--slot-avatar")?.slice(1,-1);
    }

    set color(value) {
        if(!/^#?[a-z0-9]{6}$/.test(value)) value = "#888888";
        this.#avatarNode.style.setProperty("--slot-avatar-background", value);
        this.#colorNode.value = value;
        // this.#colorText.style.color = new Color(value).invertBW;
    }
    get color() { return this.#colorNode.value }
}

QbProfileChooser.register;